import IContextDocument from "../../model/document/IContextDocument";
import { UUID } from "../../utils/typeDefinitions";
import IDocumentProvider from "./IDocumentProvider";
import Document from "../../model/document/Document";
import IBimVisualizerApiProvider from "../bimVisualizerApi/IBimVisualizerApiProvider";
import SceneObjectData from "../../model/sceneObjectData/SceneObjectData";
import IGbContext from "../../interfaces/IGbContext";

abstract class ApiDocumentProvider implements IDocumentProvider {
    
    protected apiProvider: IBimVisualizerApiProvider;
    
    constructor(apiProvider: IBimVisualizerApiProvider) {
        this.apiProvider = apiProvider;
    }
    
    abstract getDocuments(): Promise<Document[]>;
    abstract toContextDocument(doc: Document): IContextDocument;
    
    getContextQueryParams(): IGbContext | undefined {
        return undefined;
    }

    async getContextDocuments(): Promise<IContextDocument[]> {
            const docs =  await this.getDocuments();
            return docs.map(doc => this.toContextDocument(doc));
        }

    async getDocument(documentUuid: UUID): Promise<IContextDocument | null> {
        const doc = await this.apiProvider.getDocument(documentUuid, this.getContextQueryParams());
        return doc ? this.toContextDocument(doc) : null;
    }

    async saveDocument(document: IContextDocument): Promise<boolean> {
        throw new Error("Method not implemented.");
        /* const response = await this.apiProvider.addDocument(document);
        return response !== null; */
    }

    // Create initial empty document
    abstract createInitialDocument(): Promise<IContextDocument>;
    
    // Add scene object to document in the backend
    async addSceneObject(documentUuid: UUID, sceneObjectData: SceneObjectData): Promise<SceneObjectData | null> {
        const response = await this.apiProvider.addSceneObject(documentUuid, sceneObjectData);
        return response;
    }

    // Update existing scene object in the backend
    async updateSceneObject(sceneObjectUuid: UUID, sceneObjectData: SceneObjectData): Promise<SceneObjectData | null> {
        const response = await this.apiProvider.updateSceneObject(sceneObjectUuid, sceneObjectData);
        return response;
    }

    // Remove scene object from document in the backend
    async removeSceneObject(sceneObjectUuid: UUID): Promise<boolean> {
        const response = await this.apiProvider.removeSceneObject(sceneObjectUuid);
        return response;
    }
}

export default ApiDocumentProvider;